module.exports = __webpack_public_path__ + "static/media/HWMarine.88006642.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/HWMarine.webp
// module id = 124
// module chunks = 0